import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { deleteStateMasterUrl, insertStateMasterUrl, getStateMasterListUrl, updateStateMasterUrl, GET_STATE_MASTER_LIST, DELETE_STATE_MASTER, INSERT_STATE_MASTER, UPDATE_STATE_MASTER, headers } from "../../../utils/constants";

export const getStateMasterList_action = (CountryID, StateName, Status) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            CountryID: CountryID,
            StateName: StateName,
            Status: Status != '' && Status != ''? Status: null,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getStateMasterListUrl, params, headers)

        dispatch({
            type: GET_STATE_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteStateMaster_action = (StateID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            StateID: StateID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(deleteStateMasterUrl, params, headers)

        dispatch({
            type: DELETE_STATE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertStateMaster_action = (countryID, stateName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            countryID: countryID,
            stateName: stateName,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertStateMasterUrl, params, headers)

        dispatch({
            type: INSERT_STATE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateStateMaster_action = (countryID, stateID, stateName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            countryID: countryID,
            stateID: stateID,
            stateName: stateName,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updateStateMasterUrl, params, headers)

        dispatch({
            type: UPDATE_STATE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

// export const getHallMasterDetails_action = (HallId) => async (dispatch) => {
//     try {
//         const params = {
//             UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
//             ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
//             HallId: HallId
//         }
//         console.log("getVisaInvitation_action Action------->", params)

//         const res = await axiosGet(getHallMasterDetailsUrl, params, headers)

//         dispatch({
//             type: GET_HALL_MASTER_DETAILS,
//             payload: res,
//         });
//         return Promise.resolve(res)
//     } catch (error) {
//         return Promise.reject(error)
//     }
// }